import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewEncapsulation, Input, Output, Pipe, NgModule } from '@angular/core';
import * as i5 from 'base-beneficiary-documents-library';
import { BaseBeneficiaryDocumentsLibraryService } from 'base-beneficiary-documents-library';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@ngrx/store';
import * as i2 from 'ngx-toastr';
import * as i3 from 'primeng/dynamicdialog';
import * as i4 from 'step-status-update-payload-service';
import * as i6 from '@angular/router';
import * as i7 from 'app-services-library';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i9 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i10 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i11 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i12 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i13 from 'primeng/divider';
import * as i14 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i15 from 'primeng/tooltip';
import * as i16 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i17 from 'primeng/button';
import * as i18 from 'primeng/card';
import * as i19 from 'file-upload-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import * as i20 from 'send-back-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import * as i21 from 'notification-component-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import * as i22 from 'generic-beneficiary-immigration-details-library';
import { GenericBeneficiaryImmigrationDetailsLibraryModule } from 'generic-beneficiary-immigration-details-library';
import { PrimengLibraryModule } from 'primeng-library';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { SaveAsDraftModule } from 'save-as-draft';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import * as moment from 'moment';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

class BeneficiaryDocumentsLibraryService {
    constructor() { }
}
BeneficiaryDocumentsLibraryService.ɵfac = function BeneficiaryDocumentsLibraryService_Factory(t) { return new (t || BeneficiaryDocumentsLibraryService)(); };
BeneficiaryDocumentsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BeneficiaryDocumentsLibraryService, factory: BeneficiaryDocumentsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryDocumentsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "layoutCode": a0 }; };
function BeneficiaryDocumentsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵelementStart(3, "h5", 14);
    i0.ɵɵtext(4, "Provide Beneficiaries Immigration & Other documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵelementStart(6, "p", 14);
    i0.ɵɵtext(7, "Sync & Upload Supporting Beneficiary Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 16);
    i0.ɵɵelementStart(9, "ul");
    i0.ɵɵelementStart(10, "li", 17);
    i0.ɵɵelement(11, "lib-step-status-update-component-library", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li", 19);
    i0.ɵɵelement(13, "lib-maximize-dialog-library", 20);
    i0.ɵɵelementStart(14, "i", 21);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_div_1_Template_i_click_14_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("visaType", ctx_r0.inputData.caseType != "I130" ? ctx_r0.inputData.visatype : ctx_r0.inputData.caseType)("stepDetails", ctx_r0.stepDetails)("isViewMode", ctx_r0.inputData["isViewMode"])("isCaseRequest", ctx_r0.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c0, ctx_r0.inputData == null ? null : ctx_r0.inputData.layoutCode));
} }
function BeneficiaryDocumentsLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 24);
    i0.ɵɵlistener("updateStatus", function BeneficiaryDocumentsLibraryComponent_div_2_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r1.inputData.visatype)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.inputData["isViewMode"])("isCaseRequest", ctx_r1.inputData["isCaseRequest"]);
} }
function BeneficiaryDocumentsLibraryComponent_p_divider_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 25);
} }
function BeneficiaryDocumentsLibraryComponent_lib_last_update_library_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 26);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r3.stepDetails)("primaryData", ctx_r3.inputData);
} }
function BeneficiaryDocumentsLibraryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵelementStart(2, "button", 28);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_div_6_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.onClickEditImmigation(); });
    i0.ɵɵelementStart(3, "mat-icon", 29);
    i0.ɵɵtext(4, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls);
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r20.fileName, " ");
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵelement(1, "i", 54);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_7_lib_send_back_component_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-send-back-component", 59);
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabledControls", ctx_r27.disabledControls)("stepDetails", ctx_r27.stepDetails)("primaryData", ctx_r27.primaryData)("item", item_r20);
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelementStart(1, "button", 56);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const item_r20 = i0.ɵɵnextContext().$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.openDoc(item_r20); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_7_lib_send_back_component_2_Template, 1, 4, "lib-send-back-component", 57);
    i0.ɵɵelementStart(3, "button", 58);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_7_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r31); const item_r20 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.deleteImmigrationDocuments(item_r20); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !item_r20.fileLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.userType !== "Beneficiary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r24.disabledControls);
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_8_notification_component_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "notification-component-library", 61);
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("destination", ctx_r35.notifyDestinationUser)("disabledControls", ctx_r35.disabledControls)("stepDetails", ctx_r35.stepDetails)("primaryData", ctx_r35.primaryData)("item", item_r20);
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_8_notification_component_library_1_Template, 1, 5, "notification-component-library", 60);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.userType !== "Beneficiary");
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 39);
    i0.ɵɵtemplate(5, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_span_5_Template, 2, 1, "span", 8);
    i0.ɵɵtemplate(6, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_span_6_Template, 3, 0, "span", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_7_Template, 4, 3, "div", 51);
    i0.ɵɵtemplate(8, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_div_8_Template, 2, 1, "div", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (item_r20 == null ? null : item_r20.fileCategory.code) === "OTHER" && item_r20.isPresent ? item_r20 == null ? null : item_r20.fileCtaegoryOtherName : item_r20 == null ? null : item_r20.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r20.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r20.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r20 == null ? null : item_r20.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r20 == null ? null : item_r20.isPresent));
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵelement(1, "p-divider");
    i0.ɵɵelementEnd();
} }
function BeneficiaryDocumentsLibraryComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "div", 31);
    i0.ɵɵelementStart(3, "h5", 32);
    i0.ɵɵtext(4, "Beneficiary Immigration Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 33);
    i0.ɵɵelementStart(6, "button", 34);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_ng_container_7_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.syncBeneficiaryProfileData(); });
    i0.ɵɵtext(7, "SYNC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 35);
    i0.ɵɵelementStart(9, "div", 36);
    i0.ɵɵelementStart(10, "p-card", 37);
    i0.ɵɵelementStart(11, "div", 38);
    i0.ɵɵelementStart(12, "div", 39);
    i0.ɵɵelementStart(13, "h6");
    i0.ɵɵtext(14, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 39);
    i0.ɵɵelementStart(16, "h6");
    i0.ɵɵtext(17, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 40);
    i0.ɵɵelementStart(19, "h6");
    i0.ɵɵtext(20, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_21_Template, 9, 5, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 42);
    i0.ɵɵelementStart(23, "p", 43);
    i0.ɵɵtext(24, " Please upload immigration documents in the Profile section. If you delete any document here, it will be removed ONLY from this screen, NOT in the Profile section.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, BeneficiaryDocumentsLibraryComponent_ng_container_7_div_25_Template, 2, 0, "div", 44);
    i0.ɵɵelementStart(26, "div", 45);
    i0.ɵɵelementStart(27, "div", 46);
    i0.ɵɵelementStart(28, "h5", 32);
    i0.ɵɵtext(29, "Other Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 22);
    i0.ɵɵelementStart(31, "div", 47);
    i0.ɵɵelement(32, "file-upload-library", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", ctx_r5.disabledControls);
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", ctx_r5.immigrationDocuments);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.isSimplifyH1b ? false : true);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("fileUploadConfigurations", ctx_r5.otherDocumentsFileUploadConfigurations);
} }
function BeneficiaryDocumentsLibraryComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelement(1, "lib-generic-beneficiary-immigration-details-library", 64);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputData", ctx_r7.primaryData);
} }
function BeneficiaryDocumentsLibraryComponent_p_divider_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function BeneficiaryDocumentsLibraryComponent_p_divider_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function BeneficiaryDocumentsLibraryComponent_div_13_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 69);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_div_13_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.saveCloseImmigation(); });
    i0.ɵɵelementEnd();
} }
function BeneficiaryDocumentsLibraryComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 65);
    i0.ɵɵtemplate(2, BeneficiaryDocumentsLibraryComponent_div_13_button_2_Template, 1, 0, "button", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 67);
    i0.ɵɵelement(4, "lib-step-status-update-component-library", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r10.isImmigationView);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r10.inputData.caseType != "I130" ? ctx_r10.inputData.visatype : ctx_r10.inputData.caseType)("stepDetails", ctx_r10.stepDetails)("type", ctx_r10.typeOfButton)("isViewMode", ctx_r10.inputData["isViewMode"])("isCaseRequest", ctx_r10.inputData["isCaseRequest"])("showPreviousStepBtn", ctx_r10.showPrev)("showNextStepBtn", ctx_r10.showNext);
} }
function BeneficiaryDocumentsLibraryComponent_div_14_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 69);
    i0.ɵɵlistener("click", function BeneficiaryDocumentsLibraryComponent_div_14_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.saveCloseImmigation(); });
    i0.ɵɵelementEnd();
} }
function BeneficiaryDocumentsLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 70);
    i0.ɵɵtemplate(2, BeneficiaryDocumentsLibraryComponent_div_14_button_2_Template, 1, 0, "button", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r11.isImmigationView);
} }
class BeneficiaryDocumentsLibraryComponent extends BaseBeneficiaryDocumentsLibraryService {
    constructor(store, toastr, dialogService, stepStatusUpdatePayloadCostructionService, apiService, router, appServicesLibraryService) {
        super(store, toastr, dialogService, stepStatusUpdatePayloadCostructionService, apiService, router, appServicesLibraryService);
        this.store = store;
        this.toastr = toastr;
        this.dialogService = dialogService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.apiService = apiService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
        this.selectedState = 'simple';
        this.showNext = false;
        this.showPrev = false;
    }
    ngOnInit() {
        var _a, _b;
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        super.loadInit();
    }
    onChange($event) {
        this.selectedState = $event.value;
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
BeneficiaryDocumentsLibraryComponent.ɵfac = function BeneficiaryDocumentsLibraryComponent_Factory(t) { return new (t || BeneficiaryDocumentsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.DialogService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.APIBeneficiaryDocuments), i0.ɵɵdirectiveInject(i6.Router), i0.ɵɵdirectiveInject(i7.AppServicesLibraryService)); };
BeneficiaryDocumentsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: BeneficiaryDocumentsLibraryComponent, selectors: [["beneficiary-documents-library"]], inputs: { primaryData: "primaryData", simplifyH1b: "simplifyH1b" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 15, vars: 17, consts: [[1, "fluid-container"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "header-divider", 4, "ngIf"], [1, "main-body", "footer-adjust-v1", "position-relative", "pr-0"], ["sectionCode", "BEN_DOC", 3, "inputDetails", "primaryData", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["editImmigation", ""], [4, "ngIf"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection"], ["class", "row pt-3", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title", "p-0"], [1, "w-100"], [1, "mb-0"], [1, "w-100", "pt-1", "d-flex"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], ["sectionCode", "BEN_DOC", 3, "inputDetails", "primaryData"], [1, "col-12", 2, "text-align", "-webkit-right"], ["pTooltip", "Edit", 1, "btn", "custom-edit", 3, "disabled", "click"], [1, "mr-1", "icn"], [1, "row", "col-md-12", "pt-2"], [1, "p-0", "col-md-9"], [1, "sub-title"], [1, "p-0", "col-md-3"], ["pButton", "", "type", "button", "pTooltip", "Sync With Profile", "icon", "pi pi-arrow-right-arrow-left", 1, "p-button-rounded", "p-button-text", "syncBtn", 3, "disabled", "click"], [1, "row", "pt-3"], [1, "courseList", "col-md-12", "p-0"], [1, "courses-card"], [1, "row", "document-header"], [1, "col-md-5"], [1, "col-md-2"], ["class", "row document  courses-title d-flex align-items-center", 4, "ngFor", "ngForOf"], [1, "row", "col-md-12"], [1, "customUpload"], ["class", "col-md-12", 4, "ngIf"], [1, "row", "col-md-12", "pt-4"], [1, "p-0", "col-md-12"], [1, "col-md-12", "p-0", "my-3"], [1, "w-100", 3, "fileUploadConfigurations"], [1, "row", "document", "courses-title", "d-flex", "align-items-center"], ["class", "redColor d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2 pull-right d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2", 4, "ngIf"], [1, "redColor", "d-flex", "align-items-center"], [1, "pi", "pi-exclamation-triangle", "pr-2"], [1, "col-md-2", "pull-right", "d-flex", "align-items-center"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", "btnTrash", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item"], [3, "destination", "disabledControls", "stepDetails", "primaryData", "item", 4, "ngIf"], [3, "destination", "disabledControls", "stepDetails", "primaryData", "item"], [1, "col-md-12"], [1, "col-12", "p-0"], [3, "inputData"], [1, "col-md-6"], ["pButton", "", "type", "button", "label", "Close", "class", "btn-success button-width-icon-left mr-3", 3, "click", 4, "ngIf"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "isViewMode", "isCaseRequest", "showPreviousStepBtn", "showNextStepBtn"], ["pButton", "", "type", "button", "label", "Close", 1, "btn-success", "button-width-icon-left", "mr-3", 3, "click"], [1, "col-md-12", "customSave"]], template: function BeneficiaryDocumentsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, BeneficiaryDocumentsLibraryComponent_div_1_Template, 15, 7, "div", 1);
        i0.ɵɵtemplate(2, BeneficiaryDocumentsLibraryComponent_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵtemplate(3, BeneficiaryDocumentsLibraryComponent_p_divider_3_Template, 1, 0, "p-divider", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, BeneficiaryDocumentsLibraryComponent_lib_last_update_library_5_Template, 1, 2, "lib-last-update-library", 5);
        i0.ɵɵtemplate(6, BeneficiaryDocumentsLibraryComponent_div_6_Template, 6, 1, "div", 2);
        i0.ɵɵtemplate(7, BeneficiaryDocumentsLibraryComponent_ng_container_7_Template, 33, 4, "ng-container", 6);
        i0.ɵɵtemplate(8, BeneficiaryDocumentsLibraryComponent_ng_template_8_Template, 2, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, BeneficiaryDocumentsLibraryComponent_p_divider_10_Template, 1, 0, "p-divider", 8);
        i0.ɵɵelement(11, "lib-custom-questionnaire", 9);
        i0.ɵɵtemplate(12, BeneficiaryDocumentsLibraryComponent_p_divider_12_Template, 1, 0, "p-divider", 8);
        i0.ɵɵtemplate(13, BeneficiaryDocumentsLibraryComponent_div_13_Template, 5, 8, "div", 2);
        i0.ɵɵtemplate(14, BeneficiaryDocumentsLibraryComponent_div_14_Template, 3, 1, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r6 = i0.ɵɵreference(9);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isImmigationView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isImmigationView)("ngIfElse", _r6);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("stepId", ctx.primaryData.stepId)("taskId", ctx.primaryData.taskId)("viewQuestions", false)("showSaveBtn", true)("loadedIn", ctx.primaryData.stepName)("isSection", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
    } }, directives: [i8.NgIf, i9.CustomQuestionnaireComponent, i10.StepStatusUpdateComponentLibraryComponent, i11.MaximizeDialogLibraryComponent, i12.AssigningTaskLibraryComponent, i13.Divider, i14.LastUpdateLibraryComponent, i15.Tooltip, i16.MatIcon, i17.ButtonDirective, i18.Card, i8.NgForOf, i19.FileUploadLibraryComponent, i20.SendBackComponentLibraryComponent, i21.NotificationComponentLibrary, i22.GenericBeneficiaryImmigrationDetailsLibraryComponent], styles: [".close-icon{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title h5{font:normal normal 700 22px/32px Source Sans Pro;color:#3d3d63}.step-title p{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.syncBtn{width:100px!important;font-size:14px!important;font-weight:700!important}.courseList h6{color:#495057}.courses-card .document-header{background-color:#f8f9fa}.courses-card .document-header h6{font:normal normal 600 14px/20px Source Sans Pro;color:#4a4a4a}.courses-card .document-header button{color:#75777a}.courses-card h6{color:#4d4f5c;font-weight:700;font-size:13px}.courses-card div{font:normal normal normal 14px/21px Source Sans Pro;color:#4a4a4a}.courses-card button{color:#47607d!important;font-weight:bolder!important}.redColor{color:#e80b18!important}.sub-title{font:normal normal 700 22px/32px Source Sans Pro;color:#3d3d63}.custom-edit{padding:0 18px!important;border:1px solid #19a0da;display:flex;justify-content:center;align-items:center;color:#19a0da}.custom-edit mat-icon{color:#19a0da!important}.actionButtons{display:flex;justify-content:flex-end}.actionButtons button{position:relative;right:0;top:51px;z-index:1}.syncData{position:relative;left:-95px}.customUpload{color:#626262;font-size:13px}.customSave{display:flex;justify-content:flex-end}"], encapsulation: 2, data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryDocumentsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'beneficiary-documents-library',
                templateUrl: 'beneficiary-documents-library.component.html',
                styleUrls: ['beneficiary-documents-library.component.scss'],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ],
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.DialogService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.APIBeneficiaryDocuments }, { type: i6.Router }, { type: i7.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], simplifyH1b: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class ImgDateFormatPipe {
    transform(value) {
        return (value ? moment(value).format('MM/DD/YYYY') : '');
    }
}
ImgDateFormatPipe.ɵfac = function ImgDateFormatPipe_Factory(t) { return new (t || ImgDateFormatPipe)(); };
ImgDateFormatPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "ImgDateFormat", type: ImgDateFormatPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgDateFormatPipe, [{
        type: Pipe,
        args: [{ name: 'ImgDateFormat' }]
    }], null, null); })();

class BeneficiaryDocumentsLibraryModule {
}
BeneficiaryDocumentsLibraryModule.ɵfac = function BeneficiaryDocumentsLibraryModule_Factory(t) { return new (t || BeneficiaryDocumentsLibraryModule)(); };
BeneficiaryDocumentsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: BeneficiaryDocumentsLibraryModule });
BeneficiaryDocumentsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseBeneficiaryDocumentsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            NotificationComponentLibraryModule,
            SendBackComponentLibraryModule,
            DeleteDialogLibraryModule,
            FileUploadLibraryModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            CustomQuestionnaireModule,
            MatRadioModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatSelectModule,
            CommonModule,
            ReactiveFormsModule,
            MatIconModule,
            MatTabsModule,
            MatSlideToggleModule,
            MatPaginatorModule,
            MatTableModule,
            FormsModule,
            NgbModule,
            MatTooltipModule,
            MatChipsModule,
            SaveAsDraftModule,
            MatButtonToggleModule,
            GenericBeneficiaryImmigrationDetailsLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BeneficiaryDocumentsLibraryModule, { declarations: [BeneficiaryDocumentsLibraryComponent, ImgDateFormatPipe], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        NotificationComponentLibraryModule,
        SendBackComponentLibraryModule,
        DeleteDialogLibraryModule,
        FileUploadLibraryModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        CustomQuestionnaireModule,
        MatRadioModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatSelectModule,
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatTableModule,
        FormsModule,
        NgbModule,
        MatTooltipModule,
        MatChipsModule,
        SaveAsDraftModule,
        MatButtonToggleModule,
        GenericBeneficiaryImmigrationDetailsLibraryModule], exports: [BeneficiaryDocumentsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryDocumentsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [BeneficiaryDocumentsLibraryComponent, ImgDateFormatPipe],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    NotificationComponentLibraryModule,
                    SendBackComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    FileUploadLibraryModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    CustomQuestionnaireModule,
                    MatRadioModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatSelectModule,
                    CommonModule,
                    ReactiveFormsModule,
                    MatIconModule,
                    MatTabsModule,
                    MatSlideToggleModule,
                    MatPaginatorModule,
                    MatTableModule,
                    FormsModule,
                    NgbModule,
                    MatTooltipModule,
                    MatChipsModule,
                    SaveAsDraftModule,
                    MatButtonToggleModule,
                    GenericBeneficiaryImmigrationDetailsLibraryModule
                ],
                providers: [BaseBeneficiaryDocumentsLibraryService],
                exports: [BeneficiaryDocumentsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of beneficiary-documents-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BeneficiaryDocumentsLibraryComponent, BeneficiaryDocumentsLibraryModule, BeneficiaryDocumentsLibraryService };
//# sourceMappingURL=beneficiary-documents-library.js.map
